export default __webpack_public_path__ + "static/media/ms-dark.bf2cff4d.svg";